import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { getLegendValue } from '@/modules/finances/lib/expenses-metric-chart-utils';
import type { ExpensesMetricChartSeriesData } from '@/modules/finances/types';
import { ExpensesMetricChartItem } from '../expenses-metric-chart-item';
import { ExpensesMetricChartSwitch } from '../expenses-metric-chart-switch';
interface Props {
  handleToggleSeries: (series: string) => void;
  series: ExpensesMetricChartSeriesData[];
  onLegendItemHover: (legendName: string) => void;
  onLegendItemLeave: (legendName: string) => void;
  isChecked: boolean;
  handleChangeSwitch: () => void;
  showLegendValue?: boolean;
  showScrollAndToggle?: boolean;
  isCumulative?: boolean;
}
function ExpensesMetricLegend(t0) {
  const $ = _c(31);
  const {
    series,
    handleToggleSeries,
    onLegendItemHover,
    onLegendItemLeave,
    showLegendValue,
    showScrollAndToggle: t1,
    isChecked,
    handleChangeSwitch,
    isCumulative: t2
  } = t0;
  const showScrollAndToggle = t1 === undefined ? false : t1;
  const isCumulative = t2 === undefined ? false : t2;
  const t3 = showScrollAndToggle && "w-full flex-row flex-wrap items-center justify-center gap-x-2 gap-y-4";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("mx-auto mt-[22px] flex w-fit flex-col items-start justify-center gap-4", t3, "md:hidden");
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== handleToggleSeries || $[3] !== isCumulative || $[4] !== onLegendItemHover || $[5] !== onLegendItemLeave || $[6] !== series || $[7] !== showLegendValue) {
    let t6;
    if ($[9] !== handleToggleSeries || $[10] !== isCumulative || $[11] !== onLegendItemHover || $[12] !== onLegendItemLeave || $[13] !== showLegendValue) {
      t6 = element => {
        const value = getLegendValue(element, isCumulative);
        return <ExpensesMetricChartItem element={element} key={element.name} handleToggleSeries={() => {
          handleToggleSeries(element.name);
        }} onLegendItemHover={() => {
          onLegendItemHover(element.name);
        }} onLegendItemLeave={() => {
          onLegendItemLeave(element.name);
        }} showLegendValue={showLegendValue} value={value} />;
      };
      $[9] = handleToggleSeries;
      $[10] = isCumulative;
      $[11] = onLegendItemHover;
      $[12] = onLegendItemLeave;
      $[13] = showLegendValue;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = series.map(t6);
    $[2] = handleToggleSeries;
    $[3] = isCumulative;
    $[4] = onLegendItemHover;
    $[5] = onLegendItemLeave;
    $[6] = series;
    $[7] = showLegendValue;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div data-slot="legend-mobile-container" className={t4}>{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== handleChangeSwitch || $[19] !== handleToggleSeries || $[20] !== isChecked || $[21] !== isCumulative || $[22] !== onLegendItemHover || $[23] !== onLegendItemLeave || $[24] !== series || $[25] !== showLegendValue || $[26] !== showScrollAndToggle) {
    t7 = showScrollAndToggle ? <div data-slot="legend-container" className={cn("bg-card hidden", "md:flex md:h-full md:w-[231px] md:min-w-[231px] md:flex-1 md:flex-col md:justify-center md:gap-2 md:rounded-xl md:p-2 md:pb-4 md:pl-4", "lg:w-[362px] lg:min-w-[362px]", "xl:w-[355px] xl:min-w-[355px]", "2xl:w-[392px] 2xl:min-w-[392px]")}><div data-slot="switch-container" className="hidden md:flex md:w-full md:flex-row md:justify-end"><ExpensesMetricChartSwitch isChecked={isChecked} handleChangeSwitch={handleChangeSwitch} /></div><div data-slot="scroll-container" className="relative flex h-full flex-col items-center gap-1"><SimpleBar data-slot="simplebar-wrapper" className={cn("flex h-full w-full flex-col items-center justify-center", "[&_.simplebar-scrollbar::before]:ml-1 [&_.simplebar-scrollbar::before]:h-16 [&_.simplebar-scrollbar::before]:w-1 [&_.simplebar-scrollbar::before]:rounded-xl", "[&_.simplebar-scrollbar::before]:bg-muted-foreground", "md:h-[215px] md:max-h-[215px]", "lg:h-[235px] lg:max-h-[235px]", "xl:h-[300px] xl:max-h-[300px]", "2xl:h-[300px] 2xl:max-h-[300px]")}><div data-slot="series-container" className={cn("flex min-h-full flex-row flex-wrap content-start items-center justify-start gap-x-4 gap-y-4", "md:pr-3")}>{series.map(element_0 => {
              const value_0 = getLegendValue(element_0, isCumulative);
              return <ExpensesMetricChartItem element={element_0} key={element_0.name} handleToggleSeries={() => {
                handleToggleSeries(element_0.name);
              }} onLegendItemHover={() => {
                onLegendItemHover(element_0.name);
              }} onLegendItemLeave={() => {
                onLegendItemLeave(element_0.name);
              }} showLegendValue={showLegendValue} value={value_0} />;
            })}</div></SimpleBar></div></div> : <div data-slot="simple-container" className={cn("bg-accent hidden", "md:flex md:w-[231px] md:min-w-[231px] md:flex-1 md:flex-col md:items-center md:justify-center md:rounded-xl md:px-4", "lg:h-[288px]", "xl:h-[353px]", "2xl:h-[353px] 2xl:max-w-[392px]")}><div data-slot="simple-series-container" className={cn("flex flex-col items-start justify-center", series.length === 7 ? "gap-y-4" : "gap-y-6", "md:h-[268px]", "lg:h-[288px]", "xl:h-[353px]")}>{series.map(element_1 => {
          const value_1 = getLegendValue(element_1, isCumulative);
          return <ExpensesMetricChartItem element={element_1} key={element_1.name} handleToggleSeries={() => {
            handleToggleSeries(element_1.name);
          }} onLegendItemHover={() => {
            onLegendItemHover(element_1.name);
          }} onLegendItemLeave={() => {
            onLegendItemLeave(element_1.name);
          }} showLegendValue={showLegendValue} value={value_1} />;
        })}</div></div>;
    $[18] = handleChangeSwitch;
    $[19] = handleToggleSeries;
    $[20] = isChecked;
    $[21] = isCumulative;
    $[22] = onLegendItemHover;
    $[23] = onLegendItemLeave;
    $[24] = series;
    $[25] = showLegendValue;
    $[26] = showScrollAndToggle;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
export { ExpensesMetricLegend };